export type LocaleMeta = { code: string; label: string; flag: string };

// Single source of truth for lesson locales. The first entry is the default
// editing locale and the fallback used by `pickLocale` when saving.
export const LOCALES: readonly LocaleMeta[] = [
  { code: "sv-se", label: "Swedish", flag: "🇸🇪" },
  { code: "en-gb", label: "English (UK)", flag: "🇬🇧" },
  { code: "en-us", label: "English (US)", flag: "🇺🇸" },
  { code: "es-us", label: "Spanish (US)", flag: "🇪🇸" },
];

export const DEFAULT_LOCALE = LOCALES[0].code;
export const ALL_LOCALES: readonly string[] = LOCALES.map(l => l.code);

// Must stay in sync with TargetJoint.Valid() in jojnts-backend
// (internal/types/treatment.go).
export const TARGET_JOINTS = [
  "chest",
  "elbow",
  "fall_prevention",
  "foot",
  "hand",
  "hip",
  "jaw",
  "knee",
  "lower_back",
  "lower_leg",
  "neck",
  "neuro",
  "osteoporosis",
  "pelvic_floor",
  "shoulder",
  "spine",
  "upper_back",
  "wrist",
] as const;
// Allow any string from the backend; the UI selector only offers TARGET_JOINTS.
export type TargetJoint = string;

export const CONTENT_BLOCK_TYPES = ["heading", "paragraph", "image"] as const;
export type ContentBlockType = (typeof CONTENT_BLOCK_TYPES)[number];
